/**
 * Created by Litong on 17/9/1.
 */
import * as $ajax from '../router/http'
import * as Util from '../common/js/util'

// api版本
const prefix = Util.getApiVersion()
// const comm_type = exports.comm_type = {
//   comment: '1',
//   reply: '2',
//   ADMIN: '3'
// }

/**
 * 获取评论
 * @param params
 */
export function getComments (params) {
  let url = prefix + '/comment/get_comment?neid=' + params.neid

  if (!params.page_num) {
    url += '&page_num=' + 1
  } else {
    url += '&page_num=' + params.page_num
  }
  url += '&num_each_page=10'

  return $ajax.ajaxGet(encodeURI(url))
}

/**
 * 删除评论
 * @param params.uid
 * @param params.ctime
 * @param params.from_uid
 */
export function deleteComment (params) {
  let url = prefix + '/comment/delete_comment'
  var postData = {
    neid: params.neid,
    id: params.id
  }
  return $ajax.ajaxPost(encodeURI(url), postData)
}

/**
 * 发送评论
 * @param params.uid
 * @param params.content
 * @param params.commTos
 * @param params.comm_type
 * @param params.comm_icons
 */
export function createComment (params) {
  let url = prefix + '/comment/create_comment/'

  var postData = {
    words: params.words,
    neid: params.neid,
    commTos: params.commTos,
    comm_type: params.comm_type,
    comm_icon: params.comm_icon,
    id: params.id
  }

  return $ajax.ajaxPost(encodeURI(url), postData)
}

/**
 * 验证是否有权限
 * @param params.neid 评论的文件(关联iris_file_info表中元数据
 * @param params.pushId 当前用户的id
 */
export function checkWhetherAuth (params) {
  let url = prefix + '/comment/check_whether_auth'

  var postData = {
    neid: params.neid,
    pushId: params.pushId
  }

  return $ajax.ajaxPost(encodeURI(url), postData)
}

/**
 * 获取用户信息
 */
export function listForPages (params) {
  let url = prefix + '/user/list_for_pages'
  if (!params.role) {
    params.role = '1'
  }
  url += '?role=' + params.role

  if (!params.page_num) {
    url += '&page_num=0'
  } else {
    url += '&page_num=' + params.page_num
  }

  if (params.num_each_page) {
    url += '&num_each_page=' + params.num_each_page
  }

  if (params.keyword) {
    url += '&keyword=' + params.keyword
  }
  if (params.is_allow_self_cloud) {
    url += '&is_allow_self_cloud=' + params.is_allow_self_cloud
  }
  if (params.is_allow_ent_cloud) {
    url += '&is_allow_ent_cloud=' + params.is_allow_ent_cloud
  }
  // sort_by_name:self.listSort.byUpName,sort_by_email:self.listSort.ByEmail,sort_by_ctime:self.listSort.ByCtime
  if (params.sort_by_name) {
    url += '&sort_by_name=' + params.sort_by_name
  } else if (params.sort_by_email) {
    url += '&sort_by_email=' + params.sort_by_email
  } else if (params.sort_by_ctime) {
    url += '&sort_by_ctime=' + params.sort_by_ctime
  }
  return $ajax.ajaxGet(url)
}

/**
 * 获取用户信息
 */
export function searchUser (params) {
  let url = prefix + '/user_team/search?keyword=' + params.keyword + '&page_num=' + params.page_num + '&num_each_page=' + params.num_each_page + '&type=user&is_filter_master=' + params.is_filter_master
  if (params.is_allow_self_cloud) {
    url += '&is_allow_self_cloud=' + params.is_allow_self_cloud
  }
  if (params.is_allow_ent_cloud) {
    url += '&is_allow_ent_cloud=' + params.is_allow_ent_cloud
  }
  return $ajax.ajaxGet(url)
}



// WEBPACK FOOTER //
// ./src/SDK/CommentsManager.js